import React, {useEffect, useState} from 'react';
import {Link as RouterLink, useLocation} from 'react-router-dom';

// Utilities
import PropTypes from 'prop-types';
import {makeStyles} from '@mui/styles';
import {useSelector} from 'react-redux';

// Material Components
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import Hidden from '@mui/material/Hidden';
import Typography from '@mui/material/Typography';

import useMixpanel from '../../../../hooks/useMixpanel';

const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'left',
    },
    mobileDrawer: {
        width: 300
    },
    avatar: {
        cursor: 'pointer',
        width: 64,
        height: 64
    },
    boxSize: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "24px",
        gap: '16px',
        width: "268px",
        height: "165px",
        background: "#FFFFFF",
        borderRadius: "10px",
    },
    scaleDown: {
        transform: 'scale(.95)'
    },
    height: {
        height: '45px'
    },
    radius: {
        borderRadius: '20px',
        boxShadow: '-8px 13px 8px 4px rgb(0 0 0 / 37%)',
    },
    underlinedBtnText: {
        transform: 'translateY(-2px)',
        position: 'relative',
        textTransform: 'capitalize',
        fontSize: '.9rem',
        '&::after': {
            content: "''",
            position: 'absolute',
            bottom: 0,
            left: 0,
            backgroundColor: 'currentColor',
            height: 1,
            width: '100%'
        }
    },
    marginRightAuto: {
        marginRight: 'auto'
    },
    drawer: {
        width: '100%',
        maxWidth: 560
    },
    topLabel: {
        fontStyle: "normal",
        fontFamily: 'Poppins',
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "16px",
        color: "#161616",
        width: "102px",
        height: "16px",
    },
    cartLabel: {
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "16px",
        color: "#ffffff",
        width: "102px",
        height: "16px",
    },
    mainLabel: {
        fontSize: "18px",
        fontWeight: 900,
        lineHeight: "24px",
        background: "-webkit-linear-gradient(53.09deg, #122E91 6.51%, #02A29F 80.84%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent"
    },
    fuelCartLabel: {
        fontSize: "24px",
        fontWeight: 900,
        lineHeight: "24px",
        // color: "#ffffff",
        background: "-webkit-linear-gradient(53.09deg, #ffffff 6.51%, #ffffff 80.84%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent"
    },
    label2: {
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "14px",
        fontStyle: "normal",
        color: '#5C5C5C'
    },
}));

const SideBar = ({ onMobileClose, openMobile }) => {
    const { track } = useMixpanel();
    const classes = useStyles();
    const location = useLocation();
    // const dispatch = useDispatch();

    const [open, setOpen] = useState(false);

    const energy = useSelector(state => state?.getEnergy)

    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const handleMixpanelClick = () => {
        try {
            track("Referral Banner Clicked", {
                'Banner Type': 'Blue Banner',
            });
        } catch (err) {
            // Silently handle tracking errors to prevent app disruption
            console.warn('Referral banner tracking error:', err);
        }
    }


    const content = (
        <div>
            <Container className={classes.root}>
                <Box height="100%" display="flex" flexDirection="column">
                    <Box>
                    </Box>
                    <Box mt={12} component={RouterLink} to={"/addReferral"} onClick={handleMixpanelClick}>
                        <div>
                            <img
                                alt="Referral"
                                src="/static/images/banerAd/referral_banner_updated.png"
                                style={{ width: '255px', borderRadius: "10px", height: '255px' }}
                            />
                        </div>
                    </Box>
                    <Box mt={1} component={RouterLink} to={"/addReferral"} onClick={handleMixpanelClick}>
                        <div>
                            <img
                                alt="Fuel Card"
                                src="/static/images/banerAd/newBanner.webp"
                                style={{ width: '255px', borderRadius: "10px", height: '255px' }}

                            />
                        </div>
                    </Box>
                </Box>

                {
                    energy?.isLoading ?
                        <Dialog open={open}
                                onClose={handleClose}>
                            <CircularProgress />
                        </Dialog> :
                        <Dialog
                            open={open}
                            onClose={handleClose}
                        >
                            <DialogTitle>
                                KYC Score
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    <div style={{
                                        display: 'block',
                                        width: "100%",
                                        textAlign: "center",
                                        margin: "5% auto"
                                    }}>
                                        <Typography variant="h6">
                                            Do You Want to watch your KYC score?
                                        </Typography>
                                    </div>
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button

                                    onClick={handleClose}>No</Button>
                                <Button
                                    // disabled={energy?.isLoading}
                                    href={energy?.energyScore}
                                >
                                    Yes
                                </Button>
                            </DialogActions>
                        </Dialog>
                }
            </Container>
        </div>
    )
    return (
        <>
            <Hidden lgDown>
                <Drawer
                    anchor={"right"}
                    variant="persistent"
                    open
                    style={{ zIndex: '-1'}}
                >
                    {content}
                </Drawer>
            </Hidden>
        </>
    )
}

SideBar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool
}
export default SideBar